var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',{staticClass:"profileData"},[_c('Custeom-Website-Contact-Card')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }